if (!customElements.get("component-accordions")) {
  class Accordions extends HTMLElement {
    constructor() {
      super();
    }

    closeAll() {
      this.querySelectorAll(".accordion__item").forEach((item) => {
        const content = item.querySelector(".accordion__content");
        const controller = item.querySelector(".accordion__control");

        item.classList.remove("open");
        if (content) {
          content.style.maxHeight = "";
          content.setAttribute("aria-hidden", "true");
        }
        if (controller) {
          controller.setAttribute("aria-expanded", "false");
          if (controller.dataset.text) {
            controller.textContent = controller.dataset.text;
          }
        }
      });
    }

    connectedCallback() {
      this.autoScroll = this.dataset.autoScroll !== "false";

      this.accordions(
        ".accordion__item",
        ".accordion__content",
        ".accordion__control",
        "open"
      );
    }

    accordions(
      accordionsSelector,
      contentSelector,
      controlSelector,
      activeClass
    ) {
      const accordions = this.querySelectorAll(accordionsSelector);

      const scrollToItem = (item) => {
        if (!this.autoScroll) return;
        setTimeout(() => {
          item.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 600);
      };

      function openAccordion(item, content, controller) {
        if (!content || !controller) return;
        item.classList.add(activeClass);
        content.style.maxHeight = content.scrollHeight + "px";
        controller.setAttribute("aria-expanded", true);
        content.setAttribute("aria-hidden", false);

        if (controller.dataset.showLessText) {
          controller.textContent = controller.dataset.showLessText;
        }

        scrollToItem(item);
      }

      function hideAccordion(item, content, controller) {
        item.classList.remove(activeClass);
        if (content) {
          content.style.maxHeight = "";
          content.setAttribute("aria-hidden", true);
        }
        if (controller) {
          controller.setAttribute("aria-expanded", false);
          if (controller.dataset.text) {
            controller.textContent = controller.dataset.text;
          }
        }

        scrollToItem(item);
      }

      accordions.forEach((el) => {
        const content = el.querySelector(contentSelector);
        const controller = el.querySelector(controlSelector);

        if (el.classList.contains(activeClass)) {
          openAccordion(el, content, controller);
        }

        el.addEventListener("click", ({ currentTarget, target }) => {
          const currentContent = currentTarget.querySelector(contentSelector),
            currentController = currentTarget.querySelector(controlSelector);

          if (target.closest(controlSelector)) {
            if (el.classList.contains(activeClass)) {
              hideAccordion(currentTarget, currentContent, currentController);
            } else {
              accordions.forEach((item) => {
                const content = item.querySelector(contentSelector),
                  controller = item.querySelector(controlSelector);
                hideAccordion(item, content, controller);
              });

              openAccordion(currentTarget, currentContent, currentController);
            }
          }
        });
      });
    }
  }

  customElements.define("component-accordions", Accordions);
}
